import React, { memo } from 'react'
import { Box, Grid, Hidden, Typography, useTheme } from '@material-ui/core'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import moment from 'moment'
import { WrapperBox } from '~/components/layout/layout.style'
import { appStore } from '~/stores'
import { BANNER_URLS, DEFAULT_BANNER, DEFAULT_LOGO, LOGO_URLS } from './image-urls'

export const WelcomeLayout = memo(({ children, sizeLogo }) => {
	const theme = useTheme()
	const { t } = useTranslation()

	const LogoUrl = LOGO_URLS[appStore.jobBoardCode] || DEFAULT_LOGO

	const BannerUrl = BANNER_URLS[appStore.jobBoardCode] || DEFAULT_BANNER

	return (
		<WrapperBox>
			<Grid container={true} spacing={6}>
				<Grid item sm={12} md={6}>
					<Box height={'100%'} minHeight="calc(100vh - 32px)" display="flex" alignItems="center" flexDirection="column">
						<Box className={'wrapper-box-common-auth'}>
							<Box marginBottom="32px" marginTop={6} width="100%" display="flex" justifyContent="center" alignItems="center">
								<img src={LogoUrl} alt={LogoUrl} style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} width={sizeLogo || 255} />
							</Box>
							<Box>{children}</Box>
						</Box>

						<Box display="flex" alignItems="center" justifyContent="center" color={theme.colors.content.dark} width="100%" marginY={2} marginTop="auto">
							<Typography style={theme.typography.body3} color="inherit">
								{t('COPY_RIGHT', { currentYear: moment().year() })}
							</Typography>
						</Box>
					</Box>
				</Grid>
				<Hidden smDown>
					<Grid item={true} xs={12} sm={6}>
						<Box position="fixed" top="24px">
							<Box
								className={`wrapper-image ${appStore.jobBoardCode}`}
								position="relative"
								height="calc(100vh - 48px)"
								maxWidth="calc(50vw - 48px)"
								overflow="hidden"
							>
								<img src={BannerUrl} alt={BannerUrl} height="100%" width="100%" style={{ objectFit: 'cover' }} />
							</Box>
						</Box>
					</Grid>
				</Hidden>
			</Grid>
		</WrapperBox>
	)
})
